// -----------------------------------------------------------------------
// <copyright file="EduSdsTerms.tsx" company="Microsoft">
//     copyright (c) Microsoft. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------

import { ITextStyles, Link, Text } from '@fluentui/react';
import * as React from 'react';
import { getString } from '../utils/stringLoader';
import { EduSdsTermsLinks } from './eduConstants';

const paragraphStyles: ITextStyles = {
  root: {
    marginBottom: 12,
  },
};
const { OnlineServiceTerms, MicrosoftPrivacyStatement, MllCustomerSuccessDisclosure } = EduSdsTermsLinks;
const paragraph1Segments = getString('eduSdsTerms_paragraph1').split('{0}');

export const EduSdsTerms = (): JSX.Element => (
  <>
    <Text styles={paragraphStyles} block>
      {paragraph1Segments[0]}
      <Link href={OnlineServiceTerms} underline>
        {getString('eduSdsTerms_onlineServiceTerms')}
      </Link>
      {paragraph1Segments[1]}
      <Link href={MicrosoftPrivacyStatement} underline>
        {getString('eduSdsTerms_privacyStatement')}
      </Link>
      {paragraph1Segments[2]}
      <Link href={MllCustomerSuccessDisclosure} underline>
        {getString('eduSdsTerms_mllDisclosure')}
      </Link>
      {paragraph1Segments[3]}
    </Text>
    <Text styles={paragraphStyles} block>
      {getString('eduSdsTerms_paragraph2')}
    </Text>
  </>
);
